<template>
    <div class="container">
        <slick-carousel ref="slick" class="hotels-slider" :options="slickOptions" :key="carouselKey">
            <slot />
        </slick-carousel>
    </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
    components: {
        'slick-carousel': Slick,
    },

    props: {
        carouselKey: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            slickOptions: {
                autoplay: false,
                autoplaySpeed: 1000,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                dots: true,
                centerMode: true,
                centerPadding: '60px',
            },
        }
    },
}
</script>

<style lang="scss">
.hotels-slider {
    margin-left: -15px;
    margin-right: -15px;
    &.slick-dotted.slick-slider {
        margin-bottom: 0;
    }

    .slick-track {
        display: flex;
        align-items: stretch;
    }
    .slick-slide {
        display: flex;
        align-items: stretch;
        height: auto;
        & > div {
            width: 100%;
            display: flex;
            padding: 4px;
            align-items: stretch;
            height: 100%;
        }
    }

    .slick-prev,
    .slick-next {
        display: flex;
        align-items: center;
        justify-content: center;
        top: 50%;
        width: 40px;
        height: 40px;
        border-radius: 50px;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
        z-index: 10;
        transition: opacity 0.3s;
        &:hover {
            background: #fff;
        }
    }

    .slick-prev:before,
    .slick-next:before {
        content: '';
        display: block;
        height: 16px;
        width: 13px;
        opacity: 1;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }

    .slick-prev {
        left: 8px;
        &:before {
            margin-right: 2px;
            background-image: url("data:image/svg+xml,%0A%3Csvg width='19' height='20' viewBox='0 0 19 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.999999 10L4.48046 6.66667L6.93031 4.32039L11.4414 4.85949e-07L14.9219 3.33333L10.4277 7.63754L17 7.63754L17 12.3463L10.4277 12.3463L14.9219 16.6667L11.4414 20L6.93031 15.6796L4.48047 13.3333L0.999999 10Z' fill='%23B4E076'/%3E%3C/svg%3E%0A");
        }
    }
    .slick-next {
        right: 8px;
        &:before {
            margin-left: 1px;
            background-image: url("data:image/svg+xml,%0A%3Csvg width='19' height='20' viewBox='0 0 19 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18 10L14.5195 13.3333L12.0697 15.6796L7.55861 20L4.07814 16.6667L8.57233 12.3625H2L2 7.65372L8.57233 7.65372L4.07814 3.33333L7.55861 0L12.0697 4.32039L14.5195 6.66667L18 10Z' fill='%23B4E076'/%3E%3C/svg%3E%0A");
        }
    }

    .slick-dots {
        position: relative;
        bottom: auto;
        display: flex;
        justify-content: center;
        margin-top: 14px;
        li {
            width: 8px;
            height: 8px;
            button {
                padding: 0;
                background: #b4e076;
                border-radius: 50%;
                width: 8px;
                height: 8px;
                opacity: 0.4;
                &::before {
                    display: none;
                }
            }
        }
    }
    .slick-dots li.slick-active button {
        opacity: 1;
        transform: scale(1.25);
    }

    &.slick-dotted.slick-slider {
        margin-bottom: 0;
    }
}
</style>
